import { Box, Button } from '@mui/material';
import { styled } from '@mui/material/styles';

export const AddUserButton = styled(Button)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  gap: '10px',
  flexShrink: 0,
  whiteSpace: 'nowrap',
  borderRadius: 2,
  textTransform: 'none',
  border: 'none',
  '&:hover': {
    border: 'none',
    backgroundColor: theme.palette.background.default,
  },
  [theme.breakpoints.down('md')]: {
    padding: 0,
  },
}));

export const AddUserIcon = styled(Box)(({ theme }) => ({
  width: 24,
  height: 24,
  minWidth: 24,
  minHeight: 24,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: '50%',
  lineHeight: 0,
  p: 0,
  backgroundColor: theme.customColors.primary100,
}));
